export class DataHelper {
    public static async loadJSON(locale: string) {
        return await import(`@/json/${locale}.json`);
    }
}
